import React from "react";
import { SliceZone } from "@prismicio/react";

import * as Slices from "../../slices";
import CollectionSection from "../../components/collection/CollectionSection";
import { createClient } from "../../prismic";

const Collection = ({ page, slices }): JSX.Element => {
  const data = page.data;

  return (
    <>
      <SliceZone
        sliceProps={{
          pageData: data,
          globalData: page,
        }}
        {...data}
        components={Slices.components}
      />
      <CollectionSection />
    </>
  );
};

// Fetch content from prismic
export const getStaticProps = async ({ params, previewData }) => {
  const client = createClient();
  const previewRef = previewData ? previewData.ref : null;

  let refOption = previewRef ? { ref: previewRef } : {};

  const page = await client.getSingle("collection", refOption);

  return {
    props: { page, previewRef },
  };
};

export default Collection;
